import { createContext, FC, PropsWithChildren, useEffect, useState } from "react";
import { Platform } from "@yandex-int/hr-components/lib";
import { useDebounce } from "../hooks/useDebounce";

export const platformContext = createContext<Platform>(Platform.DESKTOP);

export const MobileWidthThreshold = 1000;

interface IPlatformProviderProps extends PropsWithChildren {
}

export const PlatformProvider: FC<IPlatformProviderProps> = ({ children }) => {
    const [platform, setPlatform] = useState<Platform>(Platform.DESKTOP);
    const [width, setWidth] = useState<number>(window.innerWidth);
    const debouncedWindowWidth = useDebounce(width, 100);

    const onWindowResize = () => {
        setWidth(window.innerWidth);
    }

    useEffect(() => {
        window.addEventListener("resize", onWindowResize);

        return () => {
            window.removeEventListener("resize", onWindowResize);
        }
    }, []);

    useEffect(() => {
        setPlatform(debouncedWindowWidth > MobileWidthThreshold ? Platform.DESKTOP : Platform.MOBILE)
    }, [debouncedWindowWidth])


    return <platformContext.Provider value={platform}>
        {children}
    </platformContext.Provider>;
}
